import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
var HEIGHT = 90;
export var genericErrorStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", "px;\n  margin: 0 auto ", ";\n  display: block;\n"])), HEIGHT, "var(--ds-space-300, 24px)");